module.exports = __webpack_public_path__ + "site_static/img/solution2.b44237a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solution2.png
// module id = 9esA
// module chunks = 0